var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { memo } from "react";
const SvgCurrencyMenu = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#currencyMenu_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#82A3C3",
  d: "M8 8c4.578 0 8-1.81 8-3.428 0-1.619-3.422-3.429-8-3.429-4.579 0-8 1.81-8 3.429C0 6.19 3.421 8 8 8zm0 13.714c.668 0 1.31-.04 1.923-.11a9.153 9.153 0 0 1-1.262-2.188c-.22.007-.44.012-.662.012-2.616 0-5.093-.518-6.976-1.46A9.05 9.05 0 0 1 0 17.375v.912c0 1.618 3.421 3.428 8 3.428zm0-4.572h.07a9.205 9.205 0 0 1 0-2.286l-.07.001c-2.617 0-5.094-.518-6.977-1.46A9.06 9.06 0 0 1 0 12.803v.912c0 1.618 3.421 3.428 8 3.428zm0-4.57c.226 0 .45-.005.67-.014a9.157 9.157 0 0 1 1.432-2.388 19.2 19.2 0 0 1-2.103.116c-2.616 0-5.093-.518-6.976-1.46A9.065 9.065 0 0 1 0 8.231v.912c0 1.617 3.42 3.427 8 3.427zm3.428-.362a6.82 6.82 0 0 0-1.074 4.767c.11.77.352 1.515.714 2.203a6.9 6.9 0 0 0 1.454 1.882 6.831 6.831 0 0 0 4.62 1.795A6.866 6.866 0 0 0 24 15.999a6.866 6.866 0 0 0-8.005-6.762 6.871 6.871 0 0 0-4.567 2.973z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "currencyMenu_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h24v24H0z"
})))));
const Memo = /*#__PURE__*/memo(SvgCurrencyMenu);
export default Memo;